"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrides = void 0;
var material_1 = require("@mui/material");
exports.overrides = {
    MuiToolbar: {
        styleOverrides: {
            root: function (_a) {
                var _b, _c;
                var theme = _a.theme;
                return (_b = {},
                    // NOTE: WellNow uses a different button color variation for the Header Scheduling CTA thus the following styles overrides are applied
                    _b["header &.".concat(material_1.toolbarClasses.root)] = (_c = {},
                        _c["& .".concat(material_1.buttonClasses.root, ".MuiButton-primaryAccent1")] = {
                            color: theme.palette.text.light,
                            backgroundColor: theme.palette.secondary.main,
                            '&:hover': {
                                backgroundColor: theme.palette.secondary.dark,
                            },
                            '&:focus': {
                                backgroundColor: theme.palette.secondary.dark,
                            },
                            '&:active': {
                                backgroundColor: theme.palette.secondary.light,
                            },
                            '&:disabled': {
                                backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                                color: theme.palette.text.disabled,
                            },
                        },
                        _c),
                    _b);
            },
        },
    },
};
